export default "__VITE_ASSET__EEXZ$JKw__"